export class Task {
    public static NOTIFICATIONS = 'com.explanation.NotificationTask'
    public static APP_REFRESH = 'com.explanation.AppRefreshTask'
}
